import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { DepartmentsHelpbuttonService } from 'src/app/services/helpbutton-services/departments-helpbutton-service/departments-helpbutton.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { Subscription } from 'rxjs';
import { ReportsHelpbuttonService } from 'src/app/services/helpbutton-services/reports-helpbutton-service/reports-helpbutton.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';

@Component({
  selector: 'app-helpbutton-dashboard',
  templateUrl: './helpbutton-dashboard.component.html',
  styleUrls: ['./helpbutton-dashboard.component.scss']
})
export class HelpbuttonDashboardComponent implements OnInit, OnDestroy {

  staffsCounts;
  departmentsCounts;
  assistanceNumber;
  getDepartmentsCountsSubscription: Subscription;
  getStaffsCountsSubscription: Subscription;
  getDailyReportsSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
    private staffsService: StaffsHelpbuttonService,
    private departmentsService: DepartmentsHelpbuttonService,
    private reportsService: ReportsHelpbuttonService,
    private snackbarService: SnackBarService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
  }

  ngOnInit() {
    this.setBreadcrumb();
    this.getStaffsCounts();
    this.getDepartmentsCounts();
    this.getDailyReports();
  }

  private getStaffsCounts() {
    this.getStaffsCountsSubscription = this.staffsService.getStaffsCounts().subscribe(
      (res) => {
        this.staffsCounts = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDepartmentsCounts() {
    this.getDepartmentsCountsSubscription = this.departmentsService.getDepartmentsCounts().subscribe(
      (res) => {
        this.departmentsCounts = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDailyReports() {
    const todayFrom = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime();
    const todayTo = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 0, 0, 0).getTime();
    this.getDailyReportsSubscription = this.reportsService.filterAssistanceList(this.userStorageService.getCenterList('InternalId'), todayFrom, todayTo, new Array<any>(), new Array<any>()).subscribe(
      (res) => {
        if (res) {
          this.assistanceNumber = res['data']['assistanceNumber'];
        }
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.assistanceNumber = '-';
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-street-view', 'helpbutton-page.helpbutton'));
  }

  ngOnDestroy() {
    if (this.getStaffsCountsSubscription) { this.getStaffsCountsSubscription.unsubscribe(); }
    if (this.getDepartmentsCountsSubscription) { this.getDepartmentsCountsSubscription.unsubscribe(); }
    if (this.getDailyReportsSubscription) { this.getDailyReportsSubscription.unsubscribe(); }
  }
}
